export default __webpack_public_path__ + "static/media/undraw_searching_re_3ra9.86cc06d8.svg";